module.exports = __webpack_public_path__ + "img/06.d85a39b1.png";